import { render, staticRenderFns } from "./EventsParticipantsView.vue?vue&type=template&id=c485aa76"
import script from "./EventsParticipantsView.vue?vue&type=script&lang=js"
export * from "./EventsParticipantsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports